import { SubHeading } from '@workramp/ui';
import StringUtils from '~/common/string-utils';
import { Description } from './CardText.styles';

interface CardTitleProps {
  text: string;
  color?: string;
}

interface CardDescriptionProps {
  text: string;
  color?: string;
}

export const CardTitle = ({ text, color }: CardTitleProps) => (
  <SubHeading isExpandable level="lg" maxLines={2} color={color}>
    {text}
  </SubHeading>
);

export const CardDescription = ({ text, color }: CardDescriptionProps) => (
  <Description isExpandable color={color} level="md" maxLines={3}>
    {text && StringUtils.prettifyEscapedString(text)}
  </Description>
);
